import { Button, message, Modal } from 'antd';
import React from 'react'

const CopyToTemplate = ({ isModalVisible, handleCancel, handleOk }) => {
  const handleCopy = () => {
    handleOk();
    message.success(
      `This inspection was successfully copied into template.`
    );
  };


  return (
    <div>
      <Modal
        title="Copy this Inspection into a Template?"
        open={isModalVisible}
        onCancel={handleCancel}
        onOk={handleCopy}
        centered
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Button
                onClick={handleCopy}
                type="primary"
              >
                Copy
              </Button>
              <Button onClick={handleCancel}>Cancel</Button>
            </div>
            <div></div>
          </div>
        }
      >
        <p>You are about to copy this inspection to a template. Templates can be used as a starting point for future inspections on web and mobile.</p>

      </Modal>
    </div>
  );
}

export default CopyToTemplate